module.exports = __webpack_public_path__ + "img/zhuanzhen1.da744ca8.png";